import type { AppointmentPeriodBounds } from "./resolveAppointmentFetchDateRange";

/** Modo de cruzamento com consultas FHIR no período. */
export type PatientFinderAppointmentMode =
  | "not_attended"
  | "attended"
  | "scheduled";

export const PATIENT_FINDER_APPOINTMENT_MODES: {
  value: PatientFinderAppointmentMode;
  label: string;
  shortDescription: string;
}[] = [
  {
    value: "not_attended",
    label: "Sem consulta realizada",
    shortDescription:
      "Pacientes que não tiveram atendimento concluído (fulfilled) no período.",
  },
  {
    value: "attended",
    label: "Com consulta realizada",
    shortDescription:
      "Pacientes com pelo menos uma consulta concluída (fulfilled) no período.",
  },
  {
    value: "scheduled",
    label: "Com consulta agendada",
    shortDescription:
      "Pacientes com consulta marcada, pendente ou proposta no período.",
  },
];

type FhirAppointmentStatus = "proposed" | "pending" | "booked" | "fulfilled";

/** Status enviados ao GetAppointment conforme o modo (paridade com a agenda). */
export function getAppointmentStatusesForMode(
  mode: PatientFinderAppointmentMode,
): FhirAppointmentStatus[] {
  if (mode === "scheduled") {
    return ["booked", "pending", "proposed"];
  }
  return ["fulfilled"];
}

export function isPatientFinderAppointmentMode(
  value: string,
): value is PatientFinderAppointmentMode {
  return (
    value === "not_attended" || value === "attended" || value === "scheduled"
  );
}

/** Título da seção de período conforme o modo. */
export function getAppointmentPeriodSectionTitle(
  mode: PatientFinderAppointmentMode,
): string {
  if (mode === "scheduled") {
    return "Data a partir de";
  }
  return "Intervalo de datas";
}

/** Legenda do resultado após listar. */
export function getPatientFinderResultSubtitle(
  mode: PatientFinderAppointmentMode,
  periodLabel: string,
): string {
  if (mode === "not_attended") {
    return `sem consulta realizada em ${periodLabel}`;
  }
  if (mode === "attended") {
    return `com consulta realizada em ${periodLabel}`;
  }
  return `com consulta agendada em ${periodLabel}`;
}

/** Data máxima do campo “Até”: realizadas até hoje; agendadas podem ser futuras. */
export function shouldLimitPeriodToToday(
  mode: PatientFinderAppointmentMode,
): boolean {
  return mode !== "scheduled";
}

export function defaultPatientFinderAppointmentMode(): PatientFinderAppointmentMode {
  return "not_attended";
}

export interface PatientFinderAppointmentQuery {
  mode: PatientFinderAppointmentMode;
  period: AppointmentPeriodBounds;
}
